import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SessionService } from '../../services/session2.service';
import { pathOr } from 'ramda';

@Component({
  selector: 'task-history',
  templateUrl: './task-history.component.html',
  styleUrls: ['./task-history.component.scss']
})
export class TaskHistoryComponent implements OnInit {

  @Input()
  tasks: any[] = [];

  @Output('onStopSend')
  onStopSend: EventEmitter<any> = new EventEmitter<any>();

  session: any;
  hasLabs = false;

  constructor(
    private sessionService: SessionService
  ) { }

  ngOnInit() {
    // sort contacts
    let extract = this.tasks.find(t => {return t.type == 'extract'});
    if (extract) {
      extract.detail.sort((a, b) => {
        if (a.sender) {
          return -1;
        }
        else if (b.sender) {
          return 1;
        }
        else {
          if (a.confidence > b.confidence) {
            return 1;
          }
          else {
            return -1;
          }
        }
      });
    }
    this.sessionService.getSession().subscribe((data: any) => {
      this.session = data;
    });
    if (this.session) {
      this.hasLabs = pathOr(false, ['f', 'labs'], this.session);
    }
  }

  stopPending(task: any) {
    this.onStopSend.emit(task.bq_id);
  }

}



// WEBPACK FOOTER //
// ./client/app/inbox/task-history/task-history.component.ts